import React, { useState } from "react";
import DOMPurify from "dompurify";

type ProductDetailsDropdownProps = {
  children: string;
};

const ProductDetailsDropdown = ({ children }: ProductDetailsDropdownProps) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="w-full border-t border-black">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex justify-between items-center py-3 text-left"
      >
        <span className="font-semibold uppercase tracking-wide">
          Description
        </span>
        <span className="text-xl">{open ? "−" : "+"}</span>
      </button>

      {open && (
        <div
          className="merriweather-text text-gray-900 px-4 bg-white"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(children || ""),
          }}
        />
      )}
    </div>
  );
};

export default ProductDetailsDropdown;
